'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobSpinnable', cobSpinnable);

	cobSpinnable.$inject = ['subjectObserverMessagesService', 'observerService', '$timeout'];

	var subjectObserverMessagesService, observerService, sessionService, observerMessages, $timeout;

	function cobSpinnable(_subjectObserverMessagesService_, _observerService_, _$timeout_) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		$timeout = _$timeout_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			template: '<div id= \'cob-spinner\'></div>',
			link: linkFunction
		};
	}

	function linkFunction(scope, elem) {

		activate();

		function activate() {
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			registerObserverHandlers();
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_AJAX_WAITING, handler: onWait },
					{ message: observerMessages.COB_OBSERVER_AJAX_DONE, handler: onDone }
				]);
		}

		function onDone() {
			$timeout(function() {
				elem.removeClass('spinnerOverlay');
			});

		}

		function onWait() {
			elem.addClass('spinnerOverlay');
		}
	}

})();
